module.exports = __webpack_public_path__ + "static/img/EN1.f099bc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/EN1.jpg
// module id = 5idJ
// module chunks = 1